/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmDocumentSyncRequest {
    getFixupPrototypeFunction() { return AwsSsmDocumentSyncRequest.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmDocumentSyncRequest>): AwsSsmDocumentSyncRequest {
        let obj = Object.assign(new AwsSsmDocumentSyncRequest(), model);
        AwsSsmDocumentSyncRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmDocumentSyncRequest>): AwsSsmDocumentSyncRequest {
        if (!model) return null;
        return AwsSsmDocumentSyncRequest.newInstance(<AwsSsmDocumentSyncRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmDocumentSyncRequest) {
        if (!obj) return;

        models.AwsSsmDocumentSyncRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmDocumentSyncRequest): boolean {
        Object.setPrototypeOf(obj, AwsSsmDocumentSyncRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * List of ids of the cloud account for manual document sync.
     */
    cloud_account_ids: Array<string>;

}
